import React from "react";
import { useSelector } from "react-redux";
import Button from "../../../../component/button/Button";
import useClientConfig from "../../../../config/careers/clientConfig";

const OptionSixNoJob = (props: any) => {
    const questionId = useSelector((state: any) => state?.careers?.getQuestionId);
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const noJobLang = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const noJobLangLabels = noJobLang?.noJobsSection?.[0];
    const { clientAssetsLink } = useClientConfig();
    const { navigateToJob, navigateToJobAlerts } = props;

    return (
        <section className="option6-nojob">
            <h3>{noJobLangLabels?.noJobs || "No open positions right now"}</h3>
            <p dangerouslySetInnerHTML={{ __html: noJobLangLabels?.noJobsText || "" }} />
            <div className="option6-nojob-actions">
                {questionId?.status === 200 ? (
                    <Button
                        clasName="btn option6-btn option6-btn-muted"
                        label={cliendConfig?.data?.data?.clientSettings?.registerYourInterestButtonText || noJobLangLabels?.registerYourInterest}
                        iconImg={clientAssetsLink + "/Register.svg"}
                        onClick={navigateToJob}
                    />
                ) : (
                    ""
                )}
                {cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1 ? (
                    <Button
                        clasName="btn option6-btn option6-btn-brand"
                        label={cliendConfig?.data?.data?.clientSettings?.jobAlertButtonText || noJobLangLabels?.jobAlerts}
                        iconImg={clientAssetsLink + "/Alert.svg"}
                        onClick={navigateToJobAlerts}
                    />
                ) : (
                    ""
                )}
            </div>
        </section>
    );
};

export default OptionSixNoJob;
